import React, { useState } from "react";
import Sideber from "../Components/Sidebar.jsx";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faFilter,
  faAngleDown,
  faAngleUp,
} from "@fortawesome/free-solid-svg-icons";
import Navbar from "../Components/Core/Navbar.jsx";
import Footer from "../Components/Core/Footer.jsx";
import { FaHeart } from "react-icons/fa";
import Spin from "../Components/FullscreenSpinner.jsx";
import Skeleton from "react-loading-skeleton";

const DesktopSkeleton = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        margin: "20px",
        alignItems: "center",
        justifyContent: "center",
        width: "75%",
      }}
    >
      <div style={{ display: "flex", gap: "40px", justifyContent: "center" }}>
        <Skeleton height={350} width={180} />
        <Skeleton height={350} width={180} />
        <Skeleton height={350} width={180} />
        <Skeleton height={350} width={180} />
      </div>
      <div style={{ display: "flex", gap: "40px", justifyContent: "center" }}>
        <Skeleton height={350} width={180} />
        <Skeleton height={350} width={180} />
        <Skeleton height={350} width={180} />
        <Skeleton height={350} width={180} />
      </div>
    </div>
  );
};

function Category2() {
  const [productList, setProductList] = useState([]);

  const navigate = useNavigate();
  const { subcategoryName } = useParams();
  const accessToken = localStorage.getItem("accessToken");
  const [network, setNetwork] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Run once on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const getfunction = async () => {
      try {
        setNetwork(true);
        const res = await api.get(
          `/user_api/product/get-product-list-by-subcategory?slug=${subcategoryName}`
        );
        console.log("subcategory : ", res);
        if (res.data.status === "success") {
          setProductList(res.data.product_list);
          setNetwork(false);
        }
      } catch (err) {}
    };
    getfunction();
  }, []);
  const handleFilterChange = async (filters) => {
    try {
      // Add subcategory_slug and access_token to filters
      const payload = {
        ...filters,
        slug: subcategoryName,
        access_token: JSON.parse(accessToken),
      };

      console.log("Filter payload: ", payload);
      setNetwork(true);

      const res = await api.post(`/user_api/product/filter-products`, payload);

      if (res.data.status === "success") {
        console.log("Filtered products:", res.data.product_list);
        setProductList(res.data.product_list);
        setIsSidebarOpen(false);
      } else {
        console.log("No products found");
        setProductList([]);
      }
      setNetwork(false);
    } catch (error) {
      console.error("Error filtering products:", error);
    }
  };
  const handlePress = async (url, clicked) => {
    console.log("uyghtgh", clicked);

    if (!accessToken) {
      navigate("/login");
      return;
    }

    try {
      if (!clicked) {
        navigate("/cart");
      } else {
        setNetwork(true);
        const response = await api.post(`/user_api/cart/add-to-cart-web-home`, {
          access_token: JSON.parse(accessToken),
          product_url: url,
          qty: 1,
        });
        setNetwork(false);
        console.log("jyghjgjgjh", response.data);
        if (response.data.status === "success") {
          //   getProductList();
        } else {
          console.log("something fisshy");
        }
      }
    } catch (error) {
      console.log("Error adding cart:", error);
    } finally {
    }
  };
  const addWishlist = async (id) => {
    if (!accessToken) {
      navigate("/login");
      return;
    }

    try {
      const response = await api.post(`user_api/add-wishlist`, {
        access_token: JSON.parse(accessToken),
        product_id: id,
      });

      //   getProductList();
    } catch (error) {
      console.log("Error saving wishlist:", error);
    }
  };

  return (
    <div id="wb-container" className="wb-effect10">
      {network}
      <Navbar />

      {!isMobile ? (
        // below one is gfor desktop view
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            position: "relative",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {isSidebarOpen && (
            <div style={{ width: "20%", position: "relative", left: "0",
                height: "97vh",
                overflow: "scroll", }}>
              <Sideber
                isOpen={isSidebarOpen}
                setIsOpen={setIsSidebarOpen}
                onFilterChange={handleFilterChange}
                mood={"desktop"}
              />
            </div>
          )}

          {network ? (
            <div style={{ width: "70%", paddingTop: "40px" }}>
              <DesktopSkeleton />
            </div>
          ) : (
            <div
             className="category-page"
                style={{
                  width: "79%",
                  right: "0",
                  position: "relative",

                  height: "97vh",
                  overflow: "scroll",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                      margin: "18px 0px",
    paddingBottom: "86px",
                }}
            >
              <div className="product-grid-container5">
                {productList?.length > 0 ? (
                  <div
                    className="product-grid5"
                    // style={{
                    //   display: "flex",
                    //   gap: "2rem",
                    //   flexWrap: "wrap",
                    //   alignItems: "center",
                    //   justifyContent: "center",
                    // }}
                  >
                    {productList.map((prod, i) => (
                      <div
                        key={i}
                        className="product-card5"
                        onClick={() =>
                          navigate(`/Product_details_final/${prod.product_url}`)
                        }
                      >
                        
                        <div
                          className="product-image-wrapper5"
                          // style={{
                          //   paddingTop: "0px",
                          //   backgroundColor: "white",
                          //   width: "100%",
                          //   height: "100%",
                          //   zIndex: 0,
                          // }}
                        >
                          <img
                            src={prod.product_image_path}
                            alt={prod.product_name}
                            className="product-image5"
                            // style={{
                            //   width: "100%",
                            //   height: "100%",
                            //   objectFit: "contain",
                            // }}
                          />
                          {prod.discout === 0 ? (
                          " "
                        ) : (
                          <div className="discount-badge5 pulse-animation">
                            {prod.discout}% OFF
                          </div>
                        )}
                        <div
                         className="wishlist-icon5"
                          onClick={(e) => {
                            e.stopPropagation();
                            // addWishlist(prod.id);
                          }}
                        >
                          <FaHeart
                            style={{
                              color:
                                prod.wish_button === "checked" ? "red" : "gray",
                              fontSize: "20px",
                              transition: "color 0.3s",
                            }}
                          />
                        </div>
                        </div>
                        {/* <div
                          className="product-info"
                          style={{ padding: "0px" }}
                        >
                          <h3
                            style={{
                              margin: "5px 0",
                              fontSize: "16px",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              height: "60px",
                            }}
                          >
                            {prod.product_name}
                          </h3>
                          <div
                            className="price-container"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <span className="selling-price">
                              AED{prod.selling_price}
                            </span>
                            <span className="original-price">
                              AED{prod.initial_cost}
                            </span>
                          </div>
                          <button
                            className="add-to-cart-btn1"
                            onClick={(e) => {
                              e.stopPropagation();
                              // handlePress(prod.product_url, prod.add_to_cart);
                            }}
                          >
                            <i className="fas fa-shopping-cart"></i>
                            <span>
                              {prod.add_to_cart ? "ADD TO CART" : "GO TO CART"}
                            </span>
                          </button>
                        </div> */}
                        <div
                          className="product-info5"
                          // style={{ padding: "0px" }}
                        >
                          <h3
                            className="product-name5"
                            // style={{ marginTop: "0px" }}
                          >
                            {prod.product_name}
                          </h3>

                          <div
                            className="price-section5"
                            // style={{
                            //   display: "flex",
                            //   justifyContent: "space-between",
                            //   alignItems: "center",
                            //   gap: "10px",
                            // }}
                          >
                            <span className="selling-price5">
                              AED{prod.selling_price}
                            </span>
                            <span className="original-price5">
                              AED{prod.initial_cost}
                            </span>
                          </div>

                          <button
                            className="add-to-cart-btn5"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePress(
                                prod.product_url,
                                prod.add_to_cart,
                                prod.id
                              );
                            }}
                          >
                            <i className="fas fa-shopping-cart"></i>
                            {prod.add_to_cart ? "ADD TO CART" : "GO TO CART"}
                          </button>
                        </div>
                        
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="no-products-found"
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      fontSize: "18px",
                      color: "#666",
                      width: "100%",
                    }}
                  >
                    No products found in this category
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        // below on is mobile view
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            position: "relative",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {sidebarOpen && (
            <div style={{ width: "20%", left: "0", position: "relative",height: "97vh",
                overflow: "scroll", }}>
              <Sideber
                isOpen={sidebarOpen}
                setIsOpen={setSidebarOpen}
                onFilterChange={handleFilterChange}
                mood={"mobile"}
              />
            </div>
          )}

          {network ? (
            <div style={{ width: "70%", paddingTop: "40px" }}>
              <DesktopSkeleton />
            </div>
          ) : (
            <div
              className="category-page"
              style={{
                width: "100%",
                paddingTop: "40px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {(isMobile || !sidebarOpen) && (
                <button
                  className="sidebar-toggle"
                  onClick={() => setSidebarOpen(true)}
                  style={{
                    display: "flex",
                    alignItems:"end",
                    justifyContent:"end",
                    // zIndex: 9999,
                    background: "transparent",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    width: "100%",
                  }}
                >
                  <div className="Sidebar__title" id="filter_button" style={{    width: "fit-content",
    padding: "3px 15px"}}>
                    <FontAwesomeIcon icon={faFilter} />
                    <span>Filter</span>
                  </div>
                </button>
              )}

              <div className="product-grid-container5">
                {productList?.length > 0 ? (
                  <div
                    className="product-grid5"
                    // style={{
                    //   display: "flex",
                    //   gap: "2rem",
                    //   flexWrap: "wrap",
                    //   alignItems: "center",
                    //   justifyContent: "center",
                    //   width: "100%",
                    // }}
                  >
                   {productList.map((prod, i) => (
                      <div
                        key={i}
                        className="product-card5"
                        onClick={() =>
                          navigate(`/Product_details_final/${prod.product_url}`)
                        }
                      >
                        
                        <div
                          className="product-image-wrapper5"
                          // style={{
                          //   paddingTop: "0px",
                          //   backgroundColor: "white",
                          //   width: "100%",
                          //   height: "100%",
                          //   zIndex: 0,
                          // }}
                        >
                          <img
                            src={prod.product_image_path}
                            alt={prod.product_name}
                            className="product-image5"
                            // style={{
                            //   width: "100%",
                            //   height: "100%",
                            //   objectFit: "contain",
                            // }}
                          />
                          {prod.discout === 0 ? (
                          " "
                        ) : (
                          <div className="discount-badge5 pulse-animation">
                            {prod.discout}% OFF
                          </div>
                        )}
                        <div
                         className="wishlist-icon5"
                          onClick={(e) => {
                            e.stopPropagation();
                            // addWishlist(prod.id);
                          }}
                        >
                          <FaHeart
                            style={{
                              color:
                                prod.wish_button === "checked" ? "red" : "gray",
                              fontSize: "20px",
                              transition: "color 0.3s",
                            }}
                          />
                        </div>
                        </div>
                        {/* <div
                          className="product-info"
                          style={{ padding: "0px" }}
                        >
                          <h3
                            style={{
                              margin: "5px 0",
                              fontSize: "16px",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              height: "60px",
                            }}
                          >
                            {prod.product_name}
                          </h3>
                          <div
                            className="price-container"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <span className="selling-price">
                              AED{prod.selling_price}
                            </span>
                            <span className="original-price">
                              AED{prod.initial_cost}
                            </span>
                          </div>
                          <button
                            className="add-to-cart-btn1"
                            onClick={(e) => {
                              e.stopPropagation();
                              // handlePress(prod.product_url, prod.add_to_cart);
                            }}
                          >
                            <i className="fas fa-shopping-cart"></i>
                            <span>
                              {prod.add_to_cart ? "ADD TO CART" : "GO TO CART"}
                            </span>
                          </button>
                        </div> */}
                        <div
                          className="product-info5"
                          // style={{ padding: "0px" }}
                        >
                          <h3
                            className="product-name5"
                            // style={{ marginTop: "0px" }}
                          >
                            {prod.product_name}
                          </h3>

                          <div
                            className="price-section5"
                            // style={{
                            //   display: "flex",
                            //   justifyContent: "space-between",
                            //   alignItems: "center",
                            //   gap: "10px",
                            // }}
                          >
                            <span className="selling-price5">
                              AED{prod.selling_price}
                            </span>
                            <span className="original-price5">
                              AED{prod.initial_cost}
                            </span>
                          </div>

                          <button
                            className="add-to-cart-btn5"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePress(
                                prod.product_url,
                                prod.add_to_cart,
                                prod.id
                              );
                            }}
                          >
                            <i className="fas fa-shopping-cart"></i>
                            {prod.add_to_cart ? "ADD TO CART" : "GO TO CART"}
                          </button>
                        </div>
                        
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="no-products-found"
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      fontSize: "18px",
                      color: "#666",
                      width: "100%",
                    }}
                  >
                    No products found in this category
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <Footer />
    </div>
  );
}

export default Category2;
